import ResourceModel from "models/convention-api/ResourceModel"

export default class ConventionExhibitorProfileAttachment extends ResourceModel {
  protected static basePath =
    "/v1/convention_providers/:provider_id/convention_exhibitor_profile_attachments"

  name!: string
  description!: string
  url?: string
  attachment_url?: string
}
